// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - LINER PROGRESS ||============================== //

export default function LinearProgress(theme: Theme): Record<string, any> {
  return {
    MuiLinearProgress: {
      defaultProps: {
        color: 'warning'
      },
      styleOverrides: {
        root: {
          height: 6,
          borderRadius: 100,
          backgroundColor: theme.palette.warning.lighter
        },
        bar: {
          borderRadius: 100,
          backgroundColor: theme.palette.warning.main
        }
      }
    }
  };
}
